import React from 'react';

const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = 'left',
  titleClassName = 'text-2xl md:text-2xl',
}) => {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';

  return (
    <div className={`max-w-2xl ${alignment}`}>
      {eyebrow ? <span className="section-eyebrow">{eyebrow}</span> : null}
      <h2
        className={`${
          eyebrow ? 'mt-4' : 'mt-0'
        } ${titleClassName} font-semibold tracking-tight text-stone-950`}
      >
        {title}
      </h2>
      {description ? (
        <p className="mt-2 text-base leading-7 text-stone-700 md:text-lg">
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default SectionHeading;
